import React from 'react';
import PropTypes from 'prop-types';
import getHTMLElement from '../lib/setHtmlHelper';
import { isLeadFormKeyExist } from '../lib/gatewayFormHelper';

export default class ArticleMain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gatewayForm: '',
    };
  }

  componentDidMount() {
    const articleMaincontentLinks =
      document.getElementById('mainSection') &&
      document.getElementById('mainSection').getElementsByTagName('a');
    if (articleMaincontentLinks) {
      let currentIndex = 0;
      while (currentIndex < articleMaincontentLinks.length) {
        articleMaincontentLinks[currentIndex].setAttribute(
          'data-pa-click',
          JSON.stringify({
            link: `articleMainContent-link-${this.props.articleInfo.metadata.documentId}-${articleMaincontentLinks[currentIndex].innerText}`,
            event_name: 'brc_articleMainContent_clicked'
          }),
        );
        currentIndex++;
      }
    }

    this.setState({
      gatewayForm: document.cookie,
    });
  }

  render() {
    const { content } = this.props.articleInfo;
    const mainContent = content.content;
    const innerHtml = getHTMLElement(mainContent, { useHTML: true });
    const {
      isPardotTrueExist,
      leadFormKey,
      isSlugIdExist,
      leadCapturePatdotUrl,
      isECMLive,
    } = this.props;
    const articleContainerStyle =
      isECMLive === 'true'
        ? isSlugIdExist && leadCapturePatdotUrl !== undefined
          ? isLeadFormKeyExist(leadFormKey)
            ? !isPardotTrueExist
              ? { height: '115px', overflow: 'hidden' }
              : null
            : null
          : null
        : isSlugIdExist
        ? isLeadFormKeyExist(leadFormKey)
          ? !isPardotTrueExist
            ? { height: '115px', overflow: 'hidden' }
            : null
          : null
        : null;

    return (
      <div id="mainSection" className="mainsectionContainer">
        <div>
          <div style={articleContainerStyle}>{innerHtml}</div>
        </div>
      </div>
    );
  }
}

ArticleMain.propTypes = {
  articleInfo: PropTypes.shape({
    content: PropTypes.shape({
      content: PropTypes.string,
    }),
  }),
};
